import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2b4b6f", // Deep blue
    },
    secondary: {
      main: "#ff9800", // Orange
    },
    background: {
      default: "#f4f6f8"
    }
  },
  typography: {
    fontFamily: "'Roboto', Arial, sans-serif",
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    body1: {
      fontSize: 18,
    },
    body2: {
      fontSize: 16,
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: "0 2px 16px rgba(43,75,111,0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        }
      }
    }
  }
});

export default theme;
